module.exports = __webpack_public_path__ + "img/CMATheater-Sitemap.0f0572cd.png";